import { styled } from 'styled-components';
import Flex from './Flex';
import Text from './Text';
import { useTranslation } from 'react-i18next';

type ItemCountDisplayProps = {
    title: string;
    count: number;
    countLabel: string;
    marginTop?: boolean;
};

const ItemCountDisplay: React.FC<ItemCountDisplayProps> = ({ title, count, countLabel, marginTop = true }) => {
    const { t } = useTranslation();
    return (
        <Wrapper className="item-count-display" justify="between" align="center" marginTop={marginTop}>
            <Heading as="h6" xBold fontSize={14} className="item-title">
                {title}
            </Heading>
            <Heading as="span" fontSize={14} className="item-count">
                {t('result')}: {count} {countLabel.toLowerCase()}
            </Heading>
        </Wrapper>
    );
};

export default ItemCountDisplay;

const Wrapper = styled(Flex)<{ marginTop: boolean }>`
    border-bottom: 1px solid;
    margin-top: ${({ marginTop }) => (marginTop ? '1rem' : '0')};
    /* margin-bottom: 0.5rem; */
`;

const Heading = styled(Text)`
    margin: 5px;
    /* margin-bottom: 0.5rem; */
`;
